import React from 'react';
import styled from 'styled-components';
import SbEditable from 'storyblok-react';
import BackgroundImage from 'gatsby-background-image';

import Components from '../components';
import './hero.scss';
import { fluidImage } from '../../utils/gatsbyImageTransform';

const Hero = (props) => {
  const optimizedFluidImage =
    props.blok.background_image && props.blok.background_image.filename
      ? fluidImage(props.blok.background_image.filename, { maxWidth: 2160, quality: 100 })
      : {};

  const heroClasses = ['hero'];
  heroClasses.push('halign-' + props.blok.horizontal_alignment);

  const contentClasses = ['content'];
  contentClasses.push('orientation-' + props.blok.orientation);

  if (props.blok.vertical_padding) {
    contentClasses.push('vpad-' + props.blok.vertical_padding);
  }

  return (
    <Wrapper fluid={optimizedFluidImage}>
      <SbEditable content={props.blok}>
        <section className={heroClasses.join(' ')}>
          <div className={contentClasses.join(' ')}>
            {props.blok.body.map((blok) =>
              React.createElement(Components(blok.component), { key: blok._uid, blok: blok })
            )}
          </div>
        </section>
      </SbEditable>
    </Wrapper>
  );
};

export default Hero;

const Wrapper = styled((props) => <BackgroundImage {...props} />)`
  width: 100vw;
  max-width: 100%;
  background-position: center center;
  background-size: cover;
`;
